/* eslint-disable  */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// React Components
/* eslint-disable */
import React, { useEffect, useState, Suspense, lazy } from "react";
/* eslint-disable */
import ReactDOM from "react-dom";
import "../layout-one/sass/app.scss";
import "../layout-two/sass-react/app.scss";
// React Redux
import { useSelector, useDispatch } from "react-redux";
import {
  MainApi,
  getDeviceId,
  StoreNotFound,
  freezOff,
  checkOpenBill,
  cleanCache,
  freezOn,
  resetSplitOptions,
  handleCheckCreatedAt,
  handlePromotionBanner,
  checkInvoice,
  handleError,
  tagsAndDiets,
  closeGroupBill,
  getDineInOrder,
  handleIsAddToCartEnable,
  handleSourceOfMeetBanner,
  cleanLimitedState,
  pushShopMode,
  popShopMode,
  handlepaymentMethods,
  getClosePayments,
  handlePromotionBannerBySession,
} from "../redux-store/action";
import env from "react-dotenv";
import axios from "axios";
import {
  BrowserRouter,
  Route,
  Switch,
  useParams,
  useLocation,
  withRouter,
  useHistory,
} from "react-router-dom";
import HomeOne from "../layout-one/js/Pages/Home";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CartOne from "../layout-one/js/Pages/Cart";
// import CartTwo from "../layout-two/js/Pages/Cart";
import StoreBusy from "../layout-one/js/Pages/StoreBusy";
import CircularIndeterminate from "../layout-one/js/components/CircularIndeterminate";
import Branch from "../layout-one/js/Pages/Branch";
import OpenOrder from "../layout-one/js/Pages/OpenOrder";
// import CheckOutTwoNew from "../layout-two/js-react/Pages/CheckoutNew";
import CheckOutOne from "../layout-one/js/Pages/Checkout/CheckOut";
import Products from "../layout-one/js/Pages/Products";
import SingleProduct from "../layout-one/js/Pages/SingleProduct";
import Contact from "../layout-one/js/Pages/Contact";
import Search from "../layout-one/js/Pages/Search";
import Detail from "../layout-one/js/Pages/Detail";
import Status from "../layout-one/js/Pages/Status";
import Alert from "../layout-one/js/components/Alert";
import SideComponent from "../layout-one/js/components/SideComponent";
import NotFound from "./NotFound";

import { withTranslation, Trans } from "react-i18next";
import IsClosed from "../layout-one/js/Pages/IsClosed";
import UserInfo from "../layout-one/js/components/UserInfo";
import {
  setCookie,
  getCookie,
  erase,
} from "../global-functions/cookieFunction";
import Images from "../layout-one/js/assets/images/images";

/* eslint-disable */
import ReactGa from "react-ga";
import useGaTracker from "./useGaTracker";
import Backdrop from "@mui/material/Backdrop";
import LoginModalv2Popup from "../loginSignUp/loginModalv2Popup/loginModalv2Popup";
import VerifyPhoneNumberv2Popup from "../loginSignUp/verifyPhoneNumberv2Popup/verifyPhoneNumberv2Popup";
import { orderAgain } from "../global-functions/reOrder";

import { handleMealType } from "../global-functions/mealType";
/* eslint-disable */
import ReactGA from "react-ga";
import PromotionBanner from "../sharedComponent/promotionBanner/promotionBanner";
import IFrameUrl from "../layout-one/js/components/IFrameUrl";
import { roundFixed } from "../global-functions/roundFixed";
import { configure } from "mobx";
import { useDetectAdBlock } from "adblock-detect-react";
import Error404 from "../layout-one/js/Pages/Error404/error404";
import FilterProduct from "../layout-one/js/components/filterProduct/filterProduct";
import GroupOrderPopup from "../layout-one/js/components/groupOrderPopup/groupOrderPopup";
import ShareInvoiceQrcode from "../layout-one/js/components/shareInvoiceQrcode/shareInvoiceQrcode";
import LoginModalv2Screen from "../loginSignUp/loginModalv2Screen/loginModalv2Screen";
import {
  getDineInOrders,
  getGroupBill,
  getLoyaltyCards,
  getOrderInvoice,
  handleDeliveryPreparingTime,
  handleGetBranchesList,
  handleGetCityArea,
  handleGetCountry,
  handleGetDeliveryCharges,
  handleGetDeliveryMinOrder,
  postBranch,
} from "../redux-store/action/apiCall";
import SubCategory from "../layout-one/js/components/SubCategory";
import {
  getLiveData,
  getNotification,
  getTableOrderId,
} from "../global-functions/pusher";
import CryptoJS from "crypto-js";
import LoyalityPopup from "../layout-one/js/components/loyalityPopup/loyalityPopup";
import SelectLoyaltyCardPopup from "../layout-one/js/components/selectLoyaltyCardPopup/selectLoyaltyCardPopup";
import SourceOfMeetBanner from "../sharedComponent/sourceOfMeetBanner/sourceOfMeetBanner";
import { checkHotelLoginRequired } from "../global-functions/loginAllow";
// import TestComponent from "../layout-one/js/components/TestComponent";
import LoyaltyBanner from "../sharedComponent/LoyaltyBanner/LoyaltyBanner";
import EnabillLoadingPage from "../sharedComponent/enabillLoadingPage/enabillLoadingPage";
import FeaturedProductPopup from "../layout-one/js/components/FeaturedProductPopup/FeaturedProductPopup";
import { getServiceName } from "../global-functions/variables";
import CheckoutShortCutPopup from "../layout-one/js/components/checkoutShortCutPopup/checkoutShortCutPopup";
import { Dialog } from "@mui/material";
import CloseBillCheckout from "../layout-one/js/Pages/closeBillCheckout";
import DeliveryCheckout from "../layout-one/js/Pages/Checkout/DeliveryCheckout";
import AddressFrom from "../layout-one/js/components/addressForm/AddressFrom";
import GoogleLocation from "../layout-one/js/components/googleLocation/GoogleLocation";
import GuestModal from "../loginSignUp/guestModal/GuestModal";
import { bindActionCreators } from "redux";
import { actionCreators } from "../redux-store/store";
import PixelManager from "../layout-one/js/components/pixelManager";
import NewDeliveryPopup from "../layout-one/js/components/deliveryAddsPopup/newDeliveryPopup";
import AddressFromV2 from "../layout-one/js/components/addressForm/AddressFromV2";
import PickupCheckout from "../layout-one/js/Pages/Checkout/PickupCheckout";


configure({
  isolateGlobalState: true,
});
// const TRACKING_ID = "UA-243425614-1"; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);

function PickupMain({ t, i18n }) {
  const appState = useSelector((state) => state);
  const adBlockDetected = useDetectAdBlock();
  const appDispatch = useDispatch();
  const {
    setDeliveryAddsInfo,
    setDeliveryDateTimePopup,
    setGuestLoggedIn,
    setGuestModal,
    setUserAddressPopup,
    setUserSaveDeliveryAdds,
    setDeliveryPreparingTime,
    setCurrentServices,
    setIsClosed,
    setPickupOrDelivery
  } = bindActionCreators(actionCreators, appDispatch);
  let history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const { slug } = useParams("slug");
  const appName = process.env.REACT_APP_NAME;
  const baseName = appName != 'null' ? '/' : `/${slug}`;
  const basenameSlug  = appName != 'null'   ? appName : slug;
  // console.log(basenameSlug,appName != 'null'  ,baseName  , appName, slug,  "basenameSlug") /
  let trakingDomain = window.location.host != `delivery.enabill.com`

  const [prodArry, setProdArry] = useState([]);
  const [storeFound, setStoreFound] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [branchIsLoading, setBranchIsLoading] = useState(false)
  const matches = useMediaQuery("(min-width:1200px)");
  const [winMatches, setWinMatches] = useState(
    window.matchMedia("(min-width: 760px)").winMatches
  );
  const [errorMsg, setErrorMsg] = useState("");
  const [oldInvoice, setOldInvoice] = useState(null);
  const gaEventTracker = useGaTracker("Contact us");
    const [newStore, setNewStore] = useState(false);
  
  const [invoiceId, setInvoiceId] = useState("");
  const [openOrders, setOpenOrders] = useState([]);
  const [loyaltyIsLoading, setLoyaltyIsLoading] = useState(false);
  const [initalMount, setInitalMount] = useState(true);
  let inital_mount = true;
  const [store_slug, setStore_slug] = useState(null)
  const [shopLangDefault, setShopLangDefault] = useState(
    JSON.parse(
      localStorage.getItem(`${appState.storeInfo.slug}_shopLangDefault`)
    ) !== null
      ? JSON.parse(
          localStorage.getItem(`${appState.storeInfo.slug}_shopLangDefault`)
        )
      : false
  );
  const [messages, setMessages] = useState([]);

  const handleGroupBill = () => {
    let gbID =
      searchParams.get("gb_id") != null ? searchParams.get("gb_id") : null;
    let localGbId = localStorage.getItem(`${basenameSlug}_gbId`);
    if (gbID !== null) {
      appDispatch(getGroupBill(appState, gbID));
    } else if (localGbId) {
      appDispatch(getGroupBill(appState, localGbId));
    } else {
      appDispatch(closeGroupBill(basenameSlug));
    }
  };

  const handleRemoveAuthCookie = () => {
    if (getCookie("Profile")) {
      appDispatch({
        type: "SET_LOGIN",
        loggedIn: true,
        loginToken: getCookie("tokenAuth"),
      });
      appDispatch({
        type: "SET_USERINFO",
        userInfo: JSON.parse(getCookie("Profile")),
      });
    } else {
      erase("tokenAuth");
      erase("Profile");
      erase("userInfo");
      appDispatch({
        type: "SET_LOGOUT",
        loggedIn: false,
      });
    }
  };

// set the local cart with redux cart
  useEffect(() => {
    if (basenameSlug == appState.storeInfo.slug) {
      setNewStore(false);

      let cart_name = (appState.deliveryMode && appState.pickupOrDelivery == "delivery") ? `delivery` :  appState.pickupOrDelivery == "pickup" ? `pickUp` : `menu`;


      if (appState.cart.length > 0) {
        let total = 0;
        let filterCart = initalMount
          ? appState.cart.filter((item) => item?.orderType == cart_name)
          : appState.cart;

        filterCart.forEach((element) => {
          total += element.price * element.quantity;
          if (element.sum_addons != undefined) {
            total += element.sum_addons * element.quantity;
          }
        });
        var form =
          JSON.parse(localStorage.getItem(`${basenameSlug}_form`)) !== null
            ? JSON.parse(localStorage.getItem(`${basenameSlug}_form`))
            : [];
        appDispatch({
          type: "SET_FORM_DATA",
          formData: form,
        });

        total = roundFixed(
          Number(total),
          appState.storeInfo.roundLevel,
          appState.storeInfo.roundMethod
        );
        appDispatch({ type: "updateSubTotal", subTotal: total, total: total });

        localStorage.setItem(
          `${basenameSlug}_cart`,
          JSON.stringify(filterCart)
        );
      } else {
        localStorage.setItem(
          `${basenameSlug}_cart`,
          JSON.stringify(appState.cart)
        );
      }
    }
    else {
      setNewStore(true);

      setTimeout(() => {
        setNewStore(false);
      }, 3000);
    }
  }, [appState.cart, appState.pickupOrDelivery]);

  const checkLocalCart = (cart_name) => {
    var localCart =
      JSON.parse(localStorage.getItem(`${basenameSlug}_cart`)) !== null
        ? JSON.parse(localStorage.getItem(`${basenameSlug}_cart`))
        : [];
    var form =
        JSON.parse(localStorage.getItem(`${basenameSlug}_form`)) !== null
        ? JSON.parse(localStorage.getItem(`${basenameSlug}_form`))
        : [];
        let oldCartName =
        appState.deliveryMode && appState.pickupOrDelivery == "delivery" ? `delivery` : appState.pickupOrDelivery == "pickup" ? `pickUp` : `menu`;
        
        if (appState.storeInfo.slug != basenameSlug || cart_name != oldCartName) {
          appDispatch({
            type: "SET_FORM_DATA",
            formData: form,
          });
    
          if (localCart.length > 0) {
            let filteredCart = localCart.filter(
              (item) => item?.orderType == cart_name
            );
            if (filteredCart) {
                appDispatch({
                  type: "updateCart",
                  cart: filteredCart,
                });
            }
            
          }
          else{
            appDispatch({
              type: "updateCart",
              cart: [],
            });
          }
          // appDispatch({
          //   type: "updateCart",
          //   cart: localCart,
          // });
        } else {
          if (appState.cart?.length > 0) {
            let filteredCart = localCart.filter(
              (item) => item?.orderType == cart_name
            );
            if (filteredCart) {
              appDispatch({
                type: "updateCart",
                cart: filteredCart,
              });
            }
            else{
              appDispatch({
                type: "updateCart",
                cart: [],
              });
            }
          }
          if (appState.formData?.length > 0) {
            let filteredForm = form.filter((item) => item?.orderType == cart_name);
            if (filteredForm) {
              appDispatch({
                type: "SET_FORM_DATA",
                cart: filteredForm,
              });
            }
            else{
              appDispatch({
                type: "SET_FORM_DATA",
                formData: [],
              });
            }
          }
        }
  };

  const getQr = async (delivery, branch) => {
    if (searchParams.get("table") || branch) {
      let table =
        !delivery && searchParams.get("table") != null
          ? searchParams.get("table")
          : null;

      let hotelQr =
        !delivery &&
        searchParams.get("hotelQrCode") != null &&
        searchParams.get("hotelQrCode") > 0
          ? searchParams.get("hotelQrCode")
          : null;
      let pickup =
        !delivery && searchParams.get("pickup") != null
          ? searchParams.get("pickup")
          : null;
      appDispatch({
        type: "SET_TABLE",
        qrTable: !delivery && table != null ? Number(table) : null,
      });
      appDispatch({
        type: "SET_BRANCH",
        qrBranch: branch != null ? Number(branch) : null,
      });
      appDispatch({
        type: "setHotelMode",
        hotelQrCode: hotelQr != null && !delivery ? Number(hotelQr) : null,
        hotelMode: hotelQr != null && !delivery ? true : false,
      });
      appDispatch({
        type: "setQrPickup",
        qrPickup: !delivery && pickup ? Number(pickup) : null,
      });
      // appDispatch({
      //   type: "setPickupMode",
      //   pickupMode: !delivery && pickup ? true : false,
      // });
      appDispatch({
        type: "setDeliveryMode",
        deliveryMode: delivery && branch ? true : false,
      });

      appDispatch(checkOpenBill(appState));
    } else {
      appDispatch({
        type: "setDeliveryMode",
        deliveryMode: delivery || branch ? true : false,
      });
    }
  };

  useEffect(() => {
    if (appState.deviceId) {
      getNotification(appState.deviceId, appState, appDispatch);
    }
  }, [appState.deviceId]);

  useEffect(() => {
    if (appState.qrBranch) {
      let orderInvoice = appState.openBill
        ? "open_bill"
        : appState.qrPickup
        ? "pickup"
        : "dine-in";
      localStorage.setItem(
        `${appState.storeInfo.slug}_${`delivery`}_form`,
        JSON.stringify({ ...appState.formData, order_invoice: orderInvoice })
      );
      appDispatch({
        type: "SET_FORM_DATA",
        formData: appState.formData,
        order_invoice: orderInvoice,
      });
    }
    if(appState.qrBranch != null){
      getStore(true, basenameSlug, appState.qrBranch, true);
    }
  }, [appState.qrBranch, appState.pickupOrDelivery]);
  const closeDeliveryOptions = async(delivery) => {
    if (delivery) {
      appDispatch({
        type: "setInvoiceTaxesChargesExtras",
        invoiceTaxesChargesExtras: [],
      });
    } else {
      setDeliveryAddsInfo({});
      setUserAddressPopup(false);
      setGuestLoggedIn(false);
      setDeliveryDateTimePopup(false);
      setGuestModal(false);
      setUserSaveDeliveryAdds(false);
      appDispatch({type: "setDeliveryAddsPopup",deliveryAddsPopup: false});
      appDispatch({
        type: "setCountryCityArea",
        countryCityArea: null,
      });
    }
  };

  const getBranchSetting = async (branch_id, store_id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/branch/setting?branch=${branch_id}&store=${store_id}`,
        {
          type: ["business_hours", "color", "logo", "cover" ],
        },
        {
          headers: {
            ContentType: "application/json",
          },
        }
      );

      if (response.data.success) {
        return response.data.data;
      } else {
        return null;
      }
    } catch (e) {
      return null;
      if (e.code == "ERR_NETWORK") {
        appDispatch({
          type: "SHOW_ALERT",
          alertType: "error",
          message: "Please check your network.",
        });
      } else if (e.response != undefined) {
        appDispatch(handleError(e));
      } else {
        appDispatch({
          type: "SHOW_ALERT",
          alertType: "error",
          message: "Please check your network.",
        });
      }
      if (e.code == "ERR_NETWORK") {
        setErrorMsg(e?.message);
      } else {
        setErrorMsg(e?.response?.data?.message);
      }
    }
  };  


  useEffect(() => {
   console.log(appState.isAddToCartEnable, 'appState.isAddToCartEnable')
  }, [appState.isAddToCartEnable])
  

  const getStore = async (delivery, storeSlug, branchId, firstTime = false) => {
    let branch = branchId || "";
    let table = null;
    let pickup = searchParams.get("pickup") || null;
    let hotelQr = searchParams.get("hotelQrCode") || null;
    let localGbId = localStorage.getItem(`${basenameSlug}_gbId`);
    let menu = false;
    let bannerStatus = true;
    if (firstTime) {
      setBranchIsLoading(true);
      appDispatch(freezOn());
    }

    // Dispatch device ID and freeze off
    appDispatch(getDeviceId(appState));

    // Handle QR branch change
    if (appState.qrBranch !== branch) {
      appDispatch({ type: "setLoyaltyObj", loyaltyObj: [] });
    }
   let newStoreDetacted = appState.storeInfo.slug && basenameSlug !== appState.storeInfo.slug;
  //  if(appState.branchesList.length == 0 || newStoreDetacted){
  if(inital_mount){   
    inital_mount = false;
    await handleGetBranchesList(appState, appDispatch, basenameSlug);
  }
  //  }  
    if (newStoreDetacted) {
      cleanLimitedState();
      appDispatch({ type: "SET_TABLE", qrTable: null });
      appDispatch({ type: "SET_BRANCH", qrBranch: null });
      appDispatch({ type: "setQrPickup", qrPickup: pickup });
    await closeDeliveryOptions(false);
      appDispatch({
        type: "setHotelMode",
        hotelQrCode: null,
        hotelMode: false,
      });
      appDispatch({ type: "setDeliveryMode", deliveryMode: delivery | false });
      branch = null;
    } else {
      // Handle fallback for  branch, pickup, and delivery
      branch = branch || "";
      pickup = null;
      delivery = delivery;
    }
    
    // if (delivery && basenameSlug) {
    //   let res = await handleGetCityArea(appState, appDispatch, basenameSlug);
    //   if (res == null) {
    //     setStoreFound(false);
    //     setIsLoading(false);
    //     setErrorMsg("Area Not Found");
    //     branch = null;
    //     if(branch){
    //       appDispatch({ type: "SET_BRANCH", qrBranch: null });
    //     let res2 = await handleGetCountry(appState, appDispatch, branch);
    //   }
    //   }
    //   if ((delivery, branch)) {
    //     await handleGetDeliveryCharges(appState, appDispatch, branch);
    //     await handleGetDeliveryMinOrder(appState, appDispatch, branch);
    //   let preparingTime = await handleDeliveryPreparingTime(
    //     appDispatch,
    //     branch
    //   );
    //   setDeliveryPreparingTime(preparingTime);
    // }

    // }

    await closeDeliveryOptions(delivery);
    checkLocalCart((appState.deliveryMode && appState.pickupOrDelivery == "delivery") ? `delivery` :  appState.pickupOrDelivery == "pickup" ? `pickUp` : `menu`);

    // Set query URL based on conditions
    let querryUrl =
      branch != null ? `?table=&branch=${branch}` : `?table=&branch=`; // Fallback, just branch and empty table
      
    appDispatch({
      type: "setOrderQrCode",
      orderQrCode: querryUrl,
    });

    //setup for urls
    getQr(delivery, branch);
    appDispatch(closeGroupBill(basenameSlug)); // stop group bill work for delivery

    let response = null;
    try {
      response = await axios.post(
        `${process.env.REACT_APP_API_URL}/${storeSlug}${querryUrl}`,
        {},
        {
          headers: {
            ContentType: "application/json",
          },
        }
      );
      // menu = process.env.REACT_APP_API_MENU_URL ==  process.env.REACT_APP_API_URL ?? false
      appDispatch(
        handleIsAddToCartEnable(hotelQr, pickup, table, branch, delivery)
      );
    } catch (e) {
      "New Api store not found", e;
      if (e.code == "ERR_NETWORK") {
        appDispatch({
          type: "SHOW_ALERT",
          alertType: "error",
          message: "Please check your network.",
        });
      } else if (e.response != undefined) {
      //   if(e.response == 'Branch Not Found'){
      // appDispatch({ type: "SET_BRANCH", qrBranch: null });
      //   }
        appDispatch(handleError(e));
      } else {
        appDispatch({
          type: "SHOW_ALERT",
          alertType: "error",
          message: "Please check your network.",
        });
      }
      if (e.code == "ERR_NETWORK") {
        setErrorMsg(e?.message);
      } else {
        setErrorMsg(e?.response?.data?.message);
      }

      // if (e.response.status != 200) {
      //   setErrorMsg(e.response.data.message);
      // }
      setStoreFound(false);
      setIsLoading(false);
    }

    if (response) {
      var allData = await response.data.data.store;
      let branchSettingRes = await branch ?  await getBranchSetting(branch, allData?.id)  : null;
      var invoice = await response.data.data.split_invoice_id;
      var payTable = await response.data.data.pay_table_id;
      var getOpenBillId = await response.data.data.open_bill_id;
      var hotel_qrcode_obj =
        (await response.data.data.hotel_qrcode) != undefined
          ? response.data.data.hotel_qrcode
          : null;
      var tableObj =
        (await response.data.data.table) != undefined
          ? response.data.data.table
          : null;
      var branchObj =
        (await response.data.data.branch) != undefined
          ? response.data.data.branch
          : null;
      var pickupObj =
        (await response.data.data.pickup) != undefined
          ? response.data.data.pickup
          : null;
      var settings = (await branchObj?.settings) ?? [];

      let checkScanQrCode = Boolean(
        searchParams.get("table") ||
          searchParams.get("branch") ||
          searchParams.get("hotelQrCode") ||
          searchParams.get("gb_id") ||
          searchParams.get("share-bill") ||
          delivery
      );
      appDispatch({
        type: "setOldInvoiceId",
        oldInvoice: invoice,
      });
      appDispatch({
        type: "setTableInvoice",
        tableInvoice: payTable,
      });
      appDispatch({
        type: "setOpenBillId",
        openBillId: getOpenBillId,
      });
      // if (adBlockDetected)
      if (adBlockDetected) {
        bannerStatus =
          Array.isArray(allData.banners) && allData.banners.length != 0;
      }
      const store_layout = 1;
      // if (branchObj?.loyalty_card) {
      // appDispatch(pushShopMode(appState, "Loyalty-cards"));
      // getLoyaltyCards(appState, appDispatch, branch);
      // } else {
      appDispatch(popShopMode(appState, "Loyalty-cards"));
      appDispatch({
        type: "setLoyaltyObj",
        loyaltyObj: [],
      });
      // }
      if (response.data.success === true) {
        let storeInfo = {
          businessName: allData?.business.name,
          storeId: allData?.id,
          slug: allData?.slug,
          logo: branchSettingRes?.logo ?? allData?.business.logo,
          cover: branchSettingRes?.cover ?? allData?.business.cover,
          storeMinimumOrder: allData?.business.minimum_order,
          workingHours:  branchSettingRes?.busniess_hours ?? allData?.business_hours,
          primaryColor:  branchSettingRes?.color?.primary ?? allData?.business.color.primary,
          secondaryColor: branchSettingRes?.color?.primary ?? allData?.business.color.secondary,
          progressive: allData?.progressive ?? 0,
          currencySymbol: allData?.business.currency == "SAR" ? "SAR" : allData?.business.currency == "AED" ? "AED" : "KWD",
          countryNameCode: allData?.business?.country?.code.toUpperCase() ?? "KW",
          countryNameCodess: allData?.business?.country?.code.toUpperCase() ?? "KW",
          storeCurrency:
            allData?.business.currency == "SAR"
              ? { en: "SAR", ar: "ريال" }
              : { en: "KWD", ar: "دينار" },
          storeBusyTime: allData?.busy_til,
          numberFixed: 3,
          storeBusyTime: allData?.busy_till,
          countries: allData?.countries,
          tapKey: branchObj?.tap_account?.public_key,
          tap: branchObj?.tap_account != null ? true : false,
          otp: allData?.otp,
          live: branchObj?.tap_account?.live,
          banners: branchObj?.banners,
          storeCategory: allData?.store_category,
          allowLogin: 2, // for hospital mode
            // hotelQr != null
            //   ? checkHotelLoginRequired(JSON.parse(getCookie("hotelInfo")))
            //   : branchObj?.allow_login != null
            //   ? branchObj?.allow_login.id
            //   : settings?.allow_login != null
            //   ? settings?.allow_login.id
            //   : 2,
          table: tableObj,
          branch: branchObj,
          pickup: pickupObj,
          // pos: allData?.pos,
          pos: null,
          iframeUrl: allData?.iframe_url,
          roundLevel:
            allData?.rounding != undefined
              ? allData?.rounding.level != undefined
                ? allData?.rounding.level
                : 0.001
              : 0.001,
          roundMethod:
            allData?.rounding != undefined
              ? allData?.rounding.method != undefined
                ? allData?.rounding.method
                : "average"
              : "average",
          subCategory: allData?.multiple_category,
          taxPricing: allData?.business?.tax_pricing,
          categoryProductImage: false,
          // allData?.shop_image != undefined || null
          //   ? allData?.shop_image
          //   : true,
          showProductPrice: false,  // for hospital mode
          hospitalMode: true, // for hospital mode
          meatSource:
            settings?.meat_source != null || undefined || ""
              ? settings?.meat_source
              : allData?.meat_source,
          buffetMode: allData?.id == 276 ? true : false, //276,
          checkoutShortCut: allData?.direct_checkout,
          showCalorie: allData?.show_calorie,
          defaultDeliveryCharges: branchObj?.delivery?.default_charges || 0,
          deliveryDays: Number(branchObj?.delivery?.max_days) || 365,
          pickupDays: Number(branchObj?.pickup?.max_days) || 365,
          deliveryShecheduled: branchObj?.delivery?.schedule ?? false,
          pickupShecheduled: branchObj?.pickup?.schedule || false,        
          deliveryMinimunOrder: branchObj?.delivery?.min_order || null,
          deliveryChargesName: branchObj?.delivery?.charges_name || null,
          deliveryAsap: branchObj?.delivery?.asap ?? false,
          chinessLanguage: allData?.id == 293 ? true : false,
          otpProvider: settings?.otp_provider ?? `whatsapp`,
          showSoldProduct: settings?.show_sold_product ?? true,
          hasPayMethods: (allData?.slug != 'nouga' || allData?.slug != 'lavazza')  ? true : false,
          disabledBtns:  (allData?.slug != 'nouga' || allData?.slug != 'lavazza') ? true : false,
          hiddenDiscount : (allData?.slug == 'the-hidden-egg' && branch == '259148') ? true : false,  
          defaultDeliveryPreparingTime  : branchObj?.delivery?.default_prepare_time || 0,
          storeWhatsappNumber: allData?.id == 379 ? '96522280809' : allData?.id == 358 ? '+96597970658' : null,   //379 -> sibon,  358 -> oslo
          defaultDeliveryPreparingTime  : branchObj?.delivery?.default_prepare_time?  branchObj?.delivery?.default_prepare_time : 0,
          storeWhatsappNumber: allData?.id == 379 ? '96522280809' : null,
          deliveryGiftCards: branchObj?.delivery?.delivery_gift || false,
        };
        
        // appDispatch(handleIsAddToCartEnable(hotelQr, pickup, table, branch, branchObj ));
        appDispatch(
          MainApi(
            storeInfo,
            allData,
            appState,
            payTable,
            hotelQr,
            pickup,
            hotel_qrcode_obj,
            checkScanQrCode,
            table,
            shopLangDefault,
            branchObj,
            delivery,
            settings
          )
        );
        appDispatch({
          type: "setShowTagsAndDitesFilter",
          showTagsAndDitesFilter: allData.food_preference,
        });
        appDispatch({
          type: "setFilterProductMode",
          filterProductMode: false,
        });
        var arryParentCategory = [];
        var arryCategory = [];
        var arryProduct = [];
        let currentServices = [];
        if(branchObj?.services){
          currentServices =  process.env.REACT_APP_PICKUP_DELIVERY?.split(',').includes('pickup') ? ['pick-up'] : ['delivery'];
          let storeClosed = (branchObj.services?.includes('delivery') || branchObj.services?.includes('pick-up') ) ? 0 : 1;
          setIsClosed(storeClosed)

          setCurrentServices(currentServices);
        }else{
          setIsClosed(0)
          setCurrentServices([])
        }

        
        appDispatch(checkInvoice(appState, invoice, payTable, setOldInvoice));
        appDispatch(tagsAndDiets(allData.tags, Images));
        // if(branchObj?.service){
        //   // currentServices = branchObj.services?.filter((item) => item == 'delivery' || item == "pick-up")?? []
        //   console.log('sercixe', currentServices)
        //   setCurrentServices(currentServices);
        // }else{
        //   setCurrentServices([])
        // }
        setPickupOrDelivery('pickup')
        currentServices = appState.pickupOrDelivery == 'pickup' ? ['pick-up'] : ['delivery']
        console.log(appState.pickupOrDelivery,'sercixe', currentServices)

        // Non-Progressive
        if (!allData.progressive) {
          for (var i = 0; i < allData.product_categories.length; i++) {
            var show = allData.product_categories[i]?.status;
            show =
              show == 1 || show == true || show == undefined ? true : false;
              let checkMealType = false;
              let inActive = allData.product_categories[i]?.inactive_branches.length > 0 ? allData.product_categories[i]?.inactive_branches : [];
               show =  !inActive.includes(branch);

            if (branch !== null && show) {
              
             
              if (allData.product_categories[i].mealTypes.length > 0 ) {
                let mealTypes = allData.product_categories[i].mealTypes;

             mealTypes = mealTypes.filter(
                  (mealType) => mealType?.branch_id == branch && mealType?.services?.length > 0 && mealType?.services?.some((service) =>  currentServices?.includes(service)) 
                );
                
                if(show){
                  checkMealType = mealTypes?.length > 0   
                  ? mealTypes.some((item) =>  Array.isArray(item?.services) &&   item.services.length > 0  
                  ? item.services.some((service) =>  currentServices?.includes(service)) 
                  : false ) 
                  : false; 
                }
                if (checkMealType) {
                  show = await handleMealType(
                    mealTypes,
                    branch,
                    allData.product_categories[i].id
                  );
                }
              }
            }
            var value = allData.product_categories[i];

            if (show) {
              if (allData.product_categories[i]) {
                if (storeInfo.subCategory) {
                  if (value?.children?.length == 0 && value?.has_products) {
                    let customeData = {
                      ...value,
                      parentId: value?.id,
                      has_children: value?.children?.length > 0 ? true : false,
                      childLink: `/sub-category/${value.slug}?parent=${value.id}`,
                      urlLink: `/category/${value.slug}?parent=${value.id}&catid=${value.id}`,
                    };
                    arryParentCategory.push(customeData);
                  }
                  if (value?.children?.length > 0) {
                    value?.children.forEach(async (child) => {
                      var childShow = child?.status;
                      childShow =
                        childShow == 1 ||
                        childShow == true ||
                        childShow == undefined
                          ? true
                          : false;

                      if (childShow) {
                        if (child?.mealTypes?.length > 0) {
                          let mealTypes = child.mealTypes;

                          let filterByBranch = mealTypes.filter(
                            (mealType) => mealType?.branch_id == branch
                          );
                          //  childShow = filterByBranch?.length > 0 ? filterByBranch.some((item)=> item?.services?.some((item) =>  branchObj.services?.includes(item))):true;
                          childShow =
                            filterByBranch?.length > 0
                              ? filterByBranch.some((item) =>
                                  Array.isArray(item?.services) &&
                                  item.services.length > 0
                                    ? item.services.some((service) =>
                                      currentServices?.includes(service)
                                      )
                                    : true
                                )
                              : true;
                          if (childShow) {
                            childShow = await handleMealType(mealTypes, branch);
                          }
                        }
                      }

                      if (child.has_products && childShow) {
                        let findCate = arryParentCategory.some(
                          (item) =>
                            item?.id == child?.parent?.id ||
                            item.id === value.id
                        );

                        if (!findCate) {
                          arryParentCategory.push({
                            ...value,
                            childLink: `/sub-category/${value.slug}?parent=${value.id}`,
                            urlLink: `/category/${child.slug}?parent=${value.id}&catid=${child.id}`,
                          });
                        }
                        let customeData = {
                          ...child,
                          parentId: child?.parent?.id,
                          has_children:
                            value?.children?.length > 0 ? true : false,
                          childLink: `/sub-category/${value.slug}?parent=${value.id}`,
                          urlLink: `/category/${child.slug}?parent=${value.id}&catid=${child.id}`,
                        };
                        arryCategory.push(customeData);
                      }
                    });
                  }
                } else {
                  if (hotel_qrcode_obj != null) {
                    let hotelCategory =
                      hotel_qrcode_obj?.section?.inactive_categories;
                    show = !hotelCategory.some((cat) => cat.id == value.id);
                  }
                  if (value.has_products && show) {
                    let catData = {
                      ...value,
                      has_children: value?.children?.length > 0 ? true : false,
                      urlLink: `/category/${value.slug}?catid=${value.id}`,
                    };
                    arryCategory.push(catData);
                  }
                }
              }
            }
          }
          // const result = arryParentCategory.filter(category => !arryCategory.some(paraent_cat => category.id === paraent_cat.id));
          const updatedParentCategories = arryParentCategory.map(
            (category) => ({
              ...category,
              has_children: category?.children?.length > 0 ? true : false,
            })
          );
          const result = updatedParentCategories.filter((category) => {
            // Check if category is not in arryCategory
            const isNotInCategory = !arryCategory.some(
              (parentCat) => category.id === parentCat.id
            );

            // If not in arryCategory, add `has_children` property based on `children.length`
            if (isNotInCategory) {
              return {
                ...category,
                has_children: category?.children?.length > 0 ? true : false,
              };
            }

            return false;
          });
          appDispatch({
            type: "SET_PARENT_CATEGORIES",
            parentCategories: result,
          });
          appDispatch({
            type: "SET_CATEGORIES",
            categories: arryCategory,
          });
          appDispatch({
            type: "SET_PRODUCTS",
            products: arryProduct,
          });
          appDispatch({
            type: "SET_FOR_PRODUCT_SEARCH",
            productsForSearch: arryProduct,
          });
        }
        // progressive
        else {
          appDispatch(handleCheckCreatedAt(appState));
          for (var i = 0; i < allData.product_categories.length; i++) {
            let has_parent =
              allData.product_categories[i]?.parent == null ? true : false;
            var show = (show =
              show == true || show == undefined ? true : false);
            if (branch && show && has_parent) {
              if (allData.product_categories[i].mealTypes.length > 0) {
                let mealTypes = allData?.product_categories[i]?.mealTypes;
                let filterByBranch = mealTypes.filter(
                  (mealType) => mealType?.branch_id == branch
                );
                // show = filterByBranch?.length > 0 ? filterByBranch.some((item)=> item?.services?.some((item) =>  branchObj.services?.includes(item))):true;
                show =
                  filterByBranch?.length > 0
                    ? filterByBranch.some((item) =>
                        Array.isArray(item?.services) &&
                        item.services.length > 0
                          ? item.services.some((service) =>
                               branchObj.services?.includes(service)
                            )
                          : true
                      )
                    : true;
                if (show) {
                  show = handleMealType(mealTypes, branch);
                }
              } else {
                show = true;
              }
            } else {
              show = true;
            }
            let prodShow1 = false;

            if (
              allData?.product_categories[i]?.products.length > 0 &&
              show &&
              !storeInfo.subCategory &&
              has_parent
            ) {
              let getProd = allData?.product_categories[i];
              for (var j = 0; j < getProd.products.length; j++) {
                let prod = getProd.products[j];
                if (prod != [] && !prodShow1) {
                  let inActive = prod?.inactive_branches ?? [];
                  prodShow1 =
                    inActive.length > 0
                      ? !inActive.some((item) => item == branch)
                      : true;
                }
              }
            }
            // }

            show = !storeInfo.subCategory ? prodShow1 : true;

            if (show) {
              if (allData.product_categories[i]) {
                var value = allData.product_categories[i];
                if (storeInfo.subCategory) {
                  if (value?.children.length > 0) {
                    value.children.forEach(async (child) => {
                      var childShow = child?.status;
                      childShow =
                        childShow == 1 ||
                        childShow == true ||
                        childShow == undefined
                          ? true
                          : false;

                      if (childShow) {
                        if (child.mealTypes.length > 0) {
                          let mealTypes = child.mealTypes;
                          let filterByBranch = mealTypes.filter(
                            (mealType) => mealType?.branch_id == branch
                          );
                          // childShow = filterByBranch?.length > 0 ? filterByBranch.some((item)=> item?.services?.some((item) =>  branchObj.services?.includes(item))):true;
                          childShow =
                            filterByBranch?.length > 0
                              ? filterByBranch.some((item) =>
                                  Array.isArray(item?.services) &&
                                  item.services.length > 0
                                    ? item.services.some((service) =>
                                         branchObj.services?.includes(service)
                                      )
                                    : true
                                )
                              : true;
                          if (childShow) {
                            childShow = await handleMealType(mealTypes, branch);
                          }
                        } else {
                          childShow = true;
                        }
                      }

                      if (child.products.length > 0 && childShow) {
                        let findCate = arryParentCategory.some(
                          (item) =>
                            item.id == child?.parent?.id || item.id === value.id
                        );
                        if (!findCate) {
                          let catData = {
                            ...value,
                            childLink: `/sub-category/${value.slug}?parent=${child?.parent?.id}`,
                            urlLink: `/category/${child.slug}?parent=${child?.parent?.id}&catid=${child.id}`,
                          };
                          arryParentCategory.push(catData);
                        }
                        let customeData = {
                          ...child,
                          parentId: child?.parent?.id,
                          childLink: `/sub-category/${value.slug}?parent=${child?.parent?.id}`,
                          urlLink: `/category/${child.slug}?parent=${child?.parent?.id}&catid=${child.id}`,
                        };
                        arryCategory.push(customeData);
                        for (var j = 0; j < child.products.length; j++) {
                          let prod = child.products[j];
                          if (prod != []) {
                            setProdArry([...prodArry, prod]);
                            arryProduct.push(prod);
                          }
                        }
                      }
                    });
                  }
                } else {
                  if (hotel_qrcode_obj != null) {
                    let hotelCategory =
                      hotel_qrcode_obj?.section?.inactive_categories;
                    show = !hotelCategory.some((cat) => cat.id == value.id);
                  }
                  if (value?.products.length > 0 && show) {
                    let catData = {
                      ...value,
                      urlLink: `/category/${value.slug}?catid=${value.id}`,
                    };
                    arryCategory.push(catData);
                  }
                  for (var j = 0; j < value.products.length; j++) {
                    let prod = value.products[j];
                    if (prod != []) {
                      let mealTypes = prod.mealTypes;
                      let inActive = prod?.inactive_branches ?? [];

                      let prodShow =
                        inActive.length > 0
                          ? !inActive.some((item) => item == branch)
                          : true;

                      if (mealTypes?.length > 0 && branch) {
                        let filterByBranch = mealTypes.filter(
                          (mealType) => mealType?.branch_id == branch
                        );
                        // prodShow = filterByBranch?.length > 0 ? filterByBranch.some((item)=> item?.services?.some((item) =>  branchObj.services?.includes(item))):true;
                        prodShow =
                          filterByBranch?.length > 0
                            ? filterByBranch.some((item) =>
                                Array.isArray(item?.services) &&
                                item.services.length > 0
                                  ? item.services.some((service) =>
                                      branchObj.services?.includes(service)
                                    )
                                  : true
                              )
                            : true;
                        if (prodShow) {
                          prodShow = handleMealType(mealTypes, branch);
                        }
                      }
                      if (prodShow) {
                        setProdArry([...prodArry, prod]);
                        arryProduct.push(prod);
                      }
                    }
                  }
                }
              }
            }
          }
          appDispatch({
            type: "SET_PARENT_CATEGORIES",
            parentCategories: arryParentCategory,
          });
          appDispatch({
            type: "SET_CATEGORIES",
            categories: arryCategory,
          });
          appDispatch({
            type: "SET_PRODUCTS",
            products: arryProduct,
          });
          appDispatch({
            type: "SET_FOR_PRODUCT_SEARCH",
            productsForSearch: arryProduct,
          });
        }

        if (storeInfo.progressive == 1) {
          appDispatch({
            type: "setProductsLength",
            productsLength: arryProduct.length,
          });
        } else {
          appDispatch({
            type: "setProductsLength",
            productsLength:
              allData.extra != undefined
                ? allData.extra.product_length
                  ? allData.extra.product_length
                  : 0
                : 0,
          });
        }

        const favIcon = document.getElementById("favicon");
        favIcon.href = `${allData.business.logo}`;
        if (allData.business.color.primary) {
          document.documentElement.style.setProperty(
            "--th-primary",
            allData.business.color.primary
          );
        }
        if (allData.business.color.secondary) {
          document.documentElement.style.setProperty(
            "--th-secondary",
            allData.business.color.secondary
          );
        }
        if (
          appState.qrTable != null &&
          !appState.payTableMode &&
          appState.qrBranch &&
          appState.openBill &&
          !appState.shopMode.includes("share-bill")
        ) {
          appDispatch(getDineInOrders(appState, true, setInvoiceId));
        }
        if (
          // bannerStatus &&/
          storeInfo.banners != undefined &&
          storeInfo.banners.length > 0
        ) {
          appDispatch(handlePromotionBannerBySession(appState));
        } else {
          appDispatch({ type: "setPromotionBanner", promotionBanner: false });
        }
        await appDispatch(handleSourceOfMeetBanner(storeInfo));
        setIsLoading(false);
        setBranchIsLoading(false);

      } else {
        // appDispatch(StoreNotFound());
        setStoreFound(false);
        setIsLoading(false);
        if (firstTime) {
          appDispatch(freezOff());
          setBranchIsLoading(false);
        }
      }
    }
  };
  const getBranchInfo = async () => {
    let branch = 0;
    let delivery = true;
    let pickup = searchParams.get("pickup") || null;
    getStore(delivery, basenameSlug, null, true);
  };

  useEffect(() => {
    appDispatch({
      type: "setQrOptionStatus",
      qrOptionStatus: false,
    });
  }, [appState.qrOptionStatus]);

  const handleShareBillFlow = async () => {
    let decodeId = null;
    try {
      // Your code that may throw the error here
      const encryptCode = searchParams.get("share-bill") || null;
      const decodedQrCode = decodeURIComponent(`${encryptCode}`);
      const formattedQrCode = decodedQrCode.replace(/ /g, "+");
      const decryptedBytes = CryptoJS.AES.decrypt(
        formattedQrCode,
        "hsDatawLRTS6RmGM"
      );
      decodeId = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      if (error.message.includes("Malformed UTF-8 data")) {
        // Handle the error, e.g., log it or skip the problematic data
        console.error("Malformed UTF-8 data encountered:", error);
      } else {
        // Handle other types of errors
        console.error("Other error:", error);
      }
    }

    const shareBill = decodeId || appState.shareBill?.invoiceId || null;
    let result = null;
    if (shareBill) {
      result = await getOrderInvoice(shareBill, appDispatch, appState);
      getStore(result);
    } else {
      getStore(null);
    }
  };

  useEffect(() => {
    // handle screen match
    // const handler = (e) => setWinMatches(e.matches);
    // window.matchMedia("(min-width: 760px)").addListener(handler);
    // // change url name shop with app
    // ReactGA.pageview(window.location.pathname + window.location.search);
    // let host = window.location.host;
    // if (host.split(".").length != 1) {
    //   const currentUrl = window.location.href;
    //   const currentHost = window.location.host;
    //   if (
    //     currentHost == process.env.REACT_APP_SHOP_DOMAIN ||
    //     currentHost == process.env.REACT_APP_CLIPS_DOMAIN
    //   ) {
    //     const newUrl = currentUrl.replace(
    //       window.location.host,
    //       `${process.env.REACT_APP_APP_DOMAIN}`
    //     );
    //     window.location.href = newUrl;
    //   }
    // }

    // handle version system
    const Version = "9.0.0.2";
    const currentUrl = window.location.host;

    appDispatch({
      type: "setStoreDomain",
      storeDomain: window.location.hostname,
    });
    const cookieUrl = getCookie(`${currentUrl}_version`)
      ? getCookie(`${currentUrl}_version`)
      : false;
    const localUrl = localStorage.getItem(`${currentUrl}_version`)
      ? localStorage.getItem(`${currentUrl}_version`)
      : false;
    if (cookieUrl || localUrl) {
      if (Version == cookieUrl || Version == localUrl) {
        // handleShareBillFlow();
        getBranchInfo();
      } else {
        appDispatch(cleanCache(appState));
        appDispatch(resetSplitOptions());
        setCookie(`${currentUrl}_version`, Version);
        localStorage.setItem(`${currentUrl}_version`, Version);
        appDispatch({
          type: "RESET",
        });
        // handleShareBillFlow();
        getBranchInfo();
      }
    } else {
      appDispatch({
        type: "RESET",
      });
      setCookie(`${currentUrl}_version`, Version);
      localStorage.setItem(`${currentUrl}_version`, Version);
      // handleShareBillFlow();
      getBranchInfo();
    }

    // reset some redux states
    appDispatch(resetSplitOptions());
    appDispatch({
      type: "setFilterProductMode",
      filterProductMode: false,
    });
    appDispatch({
      type: "setProductTags",
      productTags: [],
    });
    appDispatch({
      type: "setProductDietaries",
      productDietaries: [],
    });
    appDispatch({
      type: "setConfirmPopup",
      confirmPopup: false,
    });
    handleRemoveAuthCookie();
    if(appState.storeInfo.slug != basenameSlug){
      appDispatch({ type: "SET_BRANCH", qrBranch: null });
    }
     const pickupDeliveryTypes = process.env.REACT_APP_PICKUP_DELIVERY?.split(',') || ['delivery','pickup'];
    //  if(pickupDeliveryTypes.length > 1){
    //   appDispatch({ type: "SET_PICKUP_OR_DELIVERY", pickupOrDelivery: "delivery" });
    //  } else {
    //   appDispatch({ type: "SET_PICKUP_OR_DELIVERY", pickupOrDelivery: pickupDeliveryTypes[0] });
    //  }

  }, []);



  const onLanguageHandle = () => {
    i18n.changeLanguage(appState.langValue);
    localStorage.setItem(`${appState.storeInfo.slug}_shopLangDefault`, JSON.stringify(appState.langValue));
  };

  useEffect(() => {
    onLanguageHandle();
    document.documentElement.lang = appState.langValue;
  }, [appState.langValue]);

  const compareDay = async () => {
    var storeTime = "";
    storeTime = new Date(appState.storeInfo.storeBusyTime).getTime();

    if (storeTime == 0) {
      appDispatch({ type: "SET_StoreBusy", storeBusy: true });
    } else {
      var currentTime = new Date().getTime();

      var IsOpen = currentTime - storeTime;
      if (IsOpen < 0) {
        appDispatch({ type: "SET_StoreBusy", storeBusy: true });
      }
    }
  };

  useEffect(() => {
    appDispatch({ type: "SET_StoreBusy", storeBusy: false });

    if (appState.storeBusy != true && appState.storeInfo.storeBusyTime != null) {
      compareDay();
    }
  }, [isLoading]);

  useEffect(() => {
    if (
      appState.products &&
      appState.products.length > 0 &&
      appState.products != undefined
    ) {
      if (getCookie("Re-Order")) {
        appDispatch(freezOn());

        let invoiceId = getCookie("Re-Order");
        let orderResponse = orderAgain(appState, invoiceId);

        if (orderResponse.length > 0) {
          appDispatch({
            type: "updateCart",
            cart: orderResponse,
          });
          localStorage.setItem(
            `${appState.storeInfo.slug}_${`delivery`}_cart`,
            JSON.stringify(orderResponse)
          );
        } else {
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "error",
            message: t("custom-msg.product-notfound"),
          });
        }
        appDispatch(freezOff());
        erase("Re-Order");
      }
    }
  }, [appState.products]);

  const handleCloseAll = () => {
    // appDispatch({ type: "setOtpModal", otpModal: false });
    appDispatch({ type: "setLoginModal", loginModal: false });
    appDispatch({
      type: "setFilterProductMode",
      filterProductMode: false,
    });
    appDispatch({ type: "setLoginModal_Screen", loginModalScreen: false });
    appDispatch({
      type: "setShareBillPopup",
      shareBillPopup: false,
      shareBillUrl: appState.shareBillUrl,
    });
  };

  useEffect(() => {
    // console.log(
    //   "appState.loginModal",
    //   appState.loginModal,
    //   "appState.otpModal",
    //   appState.otpModal,
    //   "appState.qrOptionStatus",
    //   appState.qrOptionStatus,
    //   "appState.splitBill",
    //   appState.splitBill,
    //   "appState.paymentPopUp",
    //   appState.paymentPopUp,
    //   "appState.shareBillPopup",
    //   appState.shareBillPopup,
    //   "appState.loyalityPopupMode",
    //   appState.loyalityPopupMode,
    //   "appState.selectLoyaltyCardPopup",
    //   appState.selectLoyaltyCardPopup,
    //   "appState.optionalRewardsPopUp",
    //   appState.optionalRewardsPopUp,
    //   "appState.featuredProductPopupMode",
    //   appState.featuredProductPopupMode,
    //   "appState.payTablePopUp",
    //   appState.payTablePopUp,
    //   "appState.guestModalShow",
    //   appState.guestModalShow,
    //   "appState.userAddressPopup",
    //   appState.userAddressPopup,
    //   "appState.deliveryAddsPopup",
    //   appState.deliveryAddsPopup,
    //   "appState.promotionBanner",
    //   appState.promotionBanner
    // );
    if (
      appState.loginModal ||
      appState.otpModal ||
      appState.qrOptionStatus ||
      appState.splitBill ||
      appState.paymentPopUp ||
      appState.shareBillPopup ||
      appState.loyalityPopupMode ||
      appState.selectLoyaltyCardPopup ||
      appState.optionalRewardsPopUp ||
      appState.featuredProductPopupMode ||
      appState.payTablePopUp ||
      appState.guestModalShow ||
      appState.userAddressPopup ||
      appState.deliveryAddsPopup || 
      branchIsLoading ||
      appState.promotionBanner
    ) {
      document.body.style.overflow = "hidden";
      console.log("scrolling off");
    } else {
      document.body.style.overflow = "visible";
      console.log("scrolling start");
    }



    if(branchIsLoading){
      document.body.style.pointerEvents = "none"; // Disable pointer events
    }else{
      document.body.style.pointerEvents = "auto"; // Enable
    }



  }, [
    appState.loginModal,
    appState.otpModal,
    appState.qrOptionStatus,
    appState.splitBill,
    appState.paymentPopUp,
    appState.shareBillPopup,
    appState.loyalityPopupMode,
    appState.selectLoyaltyCardPopup,
    appState.optionalRewardsPopUp,
    appState.featuredProductPopupMode,
    appState.payTablePopUp,
    appState.guestModalShow,
    appState.userAddressPopup,
    appState.deliveryAddsPopup,
    branchIsLoading,
    appState.promotionBanner
  ]);

  const [basename, setBasename] = useState(basenameSlug);

  useEffect(() => {
    const updateManifest = async () => {
      const manifest = document.querySelector('link[rel="manifest"]');
      const appleTouchIcon = document.querySelector(
        "link[rel='apple-touch-icon']"
      );
      const metaTag = document.createElement("meta");
      const manifestUrl = manifest.getAttribute("href");

      if (appleTouchIcon) {
        appleTouchIcon.href = `${
          appState.storeInfo?.logo ||
          "https://waiter.enabill.dev/static/media/enabillJan.4d0a758b184e3ac40bb9aef3bee391e6.svg"
        }`;
      }

      if (metaTag && manifest) {
        const updatedAppName = `${
          appState.storeInfo?.businessName?.en || "Enabill"
        } (${appState.storeInfo?.branch?.name?.en || "Enabill"})`;
        metaTag.name = "apple-mobile-web-app-title";
        metaTag.content = updatedAppName;
        document.head.appendChild(metaTag);
      }

      if (manifestUrl) {
        try {
          const response = await fetch(manifestUrl);
          const data = await response.json();
          const updatedData = {
            ...data,
            start_url: `${process.env.REACT_APP_APP_DOMAIN}/${basename}?branch=${appState.qrBranch}`,
            icons: [
              {
                src: `${
                  appState.storeInfo?.logo ||
                  "https://waiter.enabill.dev/static/media/enabillJan.4d0a758b184e3ac40bb9aef3bee391e6.svg"
                }`,
                sizes: "64x64 32x32 24x24 16x16",
                type: "image/x-icon",
              },
            ],
            short_name: `${
              appState.storeInfo?.businessName?.en || "Enabill"
            } (${appState.storeInfo?.branch?.name?.en || "Enabill"})`,
            name: `${appState.storeInfo?.businessName?.en || "Enabill"} (${
              appState.storeInfo?.branch?.name?.en || "Enabill"
            })`,
          };

          const blob = new Blob([JSON.stringify(updatedData)], {
            type: "application/json",
          });
          const manifestBlobUrl = URL.createObjectURL(blob);
          manifest.setAttribute("href", manifestBlobUrl);
        } catch (error) {
          console.error("Error updating manifest start_url:", error);
        }
      }
    };

    // updateManifest();
  }, [basename, basenameSlug, appState.storeInfo]);

  useEffect(() => {
    if (appState.payTableMode) {
      getTableOrderId(appState.qrTable, appState, appDispatch, history);
    }
  }, [appState.payTableMode]);

  useEffect(() => {
    // if (appState.qrBranch && appState.shopMode.includes("Loyalty-cards")) {
    //   let result = getLoyaltyCards(appState, appDispatch);
    //   setLoyaltyIsLoading(true);
    // } else {
    //   appDispatch({
    //     type: "setLoyaltyObj",
    //     loyaltyObj: [],
    //   });
    //   setLoyaltyIsLoading(true);
    // }
   

    appDispatch({
      type: "setLoyaltyObj",
      loyaltyObj: [],
    });
    setLoyaltyIsLoading(true);
  }, [appState.loggedIn, appState.qrBranch]);

  useEffect(() => {
    if (appState?.storeInfo) {
      appDispatch(getClosePayments(appState));
    }
  }, [appState?.storeInfo]);

  useEffect(() => {
    if (appState?.storeInfo && appState?.serviceMode?.length > 0) {
      appDispatch(handlepaymentMethods(appState));
    } else {
      appDispatch({
        type: "Set_Accepted_Payments",
        acceptedPayments: appState.acceptedPayments,
      });
    }
  }, [appState?.storeInfo, appState?.closePayments, appState?.serviceMode]);
  useEffect(() => {
    if (appState.deliveryMode && !appState.deliveryAddsInfo?.city_name && !appState.qrBranch) {
      
      appDispatch({
        type: "setDeliveryAddsPopup",
        deliveryAddsPopup: true,
      });
    } else {
      appDispatch({
        type: "setDeliveryAddsPopup",
        deliveryAddsPopup: false,
      });
    }
  }, [appState.deliveryMode, appState.countryCityArea]);



  if (isLoading)
    return (
      <div>
        <EnabillLoadingPage />
      </div>
    );

  return (
    <>
    {!storeFound ? (
      <BrowserRouter basename={baseName}>
        <Route exact path="/">
          <NotFound storeName={basenameSlug} errorMessage={errorMsg} />
        </Route>
      </BrowserRouter>
    ) : (
      <div className={`layoutOne ${appState.langValue === "ar" ? "directionRtl_family" : ""}`} style={appState.langValue === "ar" ? { direction: "rtl" } : { direction: "ltr" }}>
        {appState.isClosed === 0 ? (
          <BrowserRouter basename={baseName}>
            {appState.alert.show && (
              <Alert
                type={appState.alert.type}
                show={appState.alert.show}
                message={appState.alert.message}
              />
            )}
            <div className={`row m-0 ${appState.langValue === "ar" ? "directionRtl_family" : ""}`}>
               {/* Freez Screen */}

                {appState.freezScreen && (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 9100,
                    }}
                    open={appState.freezScreen}
                  >
                    <CircularIndeterminate />
                  </Backdrop>
                )}
              <div className="offset-xl-3 mr-auto col-xl-6 p-0 leftSide" style={{ background: "white" }}>
                {appState.deliveryMode && appState.deliveryAddsPopup  && <NewDeliveryPopup />}
  
                <Switch>
                  <Route exact path="/external" component={matches ? NotFound : IFrameUrl} />
                  <Route exact path="/user" component={UserInfo} />
                  <Route exact path="/" render={() => (appState.storeBusy ? <StoreBusy /> : <HomeOne oldInvoice={oldInvoice} branchIsLoading={branchIsLoading} newStore={newStore} />)} />
                  <Route exact path="/branch" render={() => (appState.storeBusy ? <StoreBusy /> : <Branch />)} />
                  <Route exact path="/category/:slug" render={() => (appState.storeBusy ? <StoreBusy /> : <Products />)} />
                  <Route exact path="/sub-category/:slug" render={() => (appState.storeBusy ? <StoreBusy /> : <SubCategory />)} />
                  <Route exact path="/:slug/:islug" render={() => (appState.storeBusy ? <StoreBusy /> : <SingleProduct type="link-type" productInfo={{}} />)} />
                  <Route exact path="/contact" render={() => (appState.storeBusy ? <StoreBusy /> : <Contact />)} />
                  <Route exact path="/detail" render={() => (appState.storeBusy ? <StoreBusy /> : <Detail />)} />
                  <Route exact path="/checkout" render={() => appState.storeBusy ? <StoreBusy /> : appState.pickupOrDelivery === "delivery" ? <DeliveryCheckout oldInvoice={oldInvoice} />: appState.pickupOrDelivery === "pickup" ? <PickupCheckout oldInvoice={oldInvoice} /> : <CheckOutOne oldInvoice={oldInvoice} />} />
                  <Route exact path="/search" render={() => (appState.storeBusy ? <StoreBusy /> : <Search />)} />
                  <Route exact path="/status" render={() => (appState.storeBusy ? <StoreBusy /> : <Status />)} />
                  <Route exact path="/address-form" render={() => (appState.storeBusy ? <StoreBusy /> : <AddressFromV2 />)} />
                  <Route exact path="/map" render={() => (appState.storeBusy ? <StoreBusy /> : <GoogleLocation />)} />
                  <Route exact path="/cart" render={() => (appState.storeBusy ? <StoreBusy /> : <CartOne />)} />
                  <Route exact path="/openorder" render={() => (appState.storeBusy ? <StoreBusy openOrders={openOrders} /> : <OpenOrder />)} />
                  <Route exact path="/circularindeterminate" component={CircularIndeterminate} />
                  <Route exact path="*" component={Error404} />
                </Switch>
  
                {appState.loginModal && <LoginModalv2Popup />}
                {appState.loginModalScreen && <LoginModalv2Screen />}
                {appState.otpModal && <VerifyPhoneNumberv2Popup />}
                {appState.promotionBanner && appState.storeInfo.banners?.length > 0 && <PromotionBanner />}
                {appState.sourceOfMeetBannerImage && <SourceOfMeetBanner />}
                {appState.guestModalShow && <GuestModal />}
                {appState.groupOrderPopup && appState.qrBranch && <GroupOrderPopup />}
                {appState.shareBillPopup && <ShareInvoiceQrcode />}
                {appState.filterProductMode && <FilterProduct />}
                {appState.progressive === 1 && appState.loyalityPopupMode && <LoyalityPopup />}
              </div>
            </div>
          </BrowserRouter>
        ) : (
          <div className="offset-xl-3 mr-auto col-xl-6 p-0 leftSide" style={{ background: "white" }}>

          <IsClosed />
          </div>
        )}
  
        {(appState.loginModal ||
          appState.otpModal ||
          appState.filterProductMode ||
          appState.groupOrderPopup ||
          appState.loyalityPopupMode ||
          appState.loginModalScreen ||
          appState.shareBillPopup ||
          appState.featuredProductPopupMode ||
          appState.guestModalShow) && (
          <Backdrop
            onClick={handleCloseAll}
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 3 }}
            open
          />
        )}
      </div>
    )}
{ !trakingDomain && <PixelManager />}
  </>
  
  

    // test
  );
}

export default withTranslation()(PickupMain);